<template>
  <add-dispatch-car-real
    v-if="show"
    @reset="reset"
    :dispatchId="dispatchId"
    :isSee="isSee == 1"
    :type="type"
    :op="op"
  ></add-dispatch-car-real>
</template>

<script>
import AddDispatchCarReal from "./AddDispatchCarReal.vue";
export default {
  components: {
    AddDispatchCarReal,
  },
  props: {
    dispatchId: {
      type: String,
      require: false,
      default() {
        return null;
      },
    },
    isSee: {},
    type:{
      type:String,
      require:false,
      default:'edit'
    },
    op:{
      type:String,
      require:false,
      default:'edit'
    },
  },
  data() {
    return {
      show: true,
    };
  },
  methods: {
    async reset() {
      this.show = false;
      await this.$nextTick();
      this.show = true;
    },
  },
};
</script>

<style>
</style>